import { Component, OnDestroy, OnInit, PLATFORM_ID, ViewChild, inject } from '@angular/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CookieService } from '../../shared/services/cookie.service';
import { Observable, Subscription } from 'rxjs';
import {
  BreakpointObserver,
  BreakpointState,
  Breakpoints
} from '@angular/cdk/layout';
import { GoogleTagManagerService } from '../../shared/services/google-tag-manager.service';
import {
  ConsentService,
  ConsentSettings
} from '../../shared/services/consent.service';
import { RouterLink } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggle, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { isPlatformBrowser } from '@angular/common';
declare var FreshworksWidget;
@Component({
    selector: 'app-cookie-settings',
    templateUrl: './cookie-settings.component.html',
    styleUrls: ['./cookie-settings.component.scss'],
    standalone: true,
    imports: [RouterLink, MatButtonModule, MatExpansionModule, MatSlideToggle, MatDialogModule]
})
export class CookieSettingsComponent implements OnInit, OnDestroy {
  dialogRef = inject<MatDialogRef<any>>(MatDialogRef);
  private dialogService = inject(MatDialog);
  private cookieService = inject(CookieService);
  private dialog = inject(MatDialog);
  private breakpointObserver = inject(BreakpointObserver);
  private gtmService = inject(GoogleTagManagerService);
  private consentService = inject(ConsentService);

  @ViewChild('customSettings') customSettings: any;

  analyticsCookie: boolean = true;
  adsCookie: boolean = true;
  analyticsMeasurementID: string;
  private isSmallBreakpoint: Observable<BreakpointState> ;
  private consentSubscription!: Subscription;
  private platformId = inject(PLATFORM_ID); 
  consentSettings: ConsentSettings = {
    analytics_storage: 'granted',
    ad_storage: 'granted',
    ad_user_data: 'granted',
    ad_personalization: 'granted'
  };
  constructor() {
    
  }

  ngOnInit(): void {
    if(isPlatformBrowser(this.platformId)){
      this.isSmallBreakpoint =
      this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]);
      this.consentSubscription = this.consentService.currentConsent$.subscribe(
        (currentStatus) => {
          if (currentStatus) {
            this.consentSettings = { ...currentStatus }; // Create a copy for local modifications
          }
          // Show banner if no choice has been made previously
        }
      );
  
      const smallDialogSubscription = this.isSmallBreakpoint.subscribe((size) => {
        if (size.matches) {
          this.dialogRef.updateSize('100%');
        } else {
          this.dialogRef.updateSize('500px');
        }
      });
  
      this.dialogRef.afterClosed().subscribe(() => {
        smallDialogSubscription.unsubscribe();
      });
    }
  }

  acceptAll() {
    this.consentSettings = {
      analytics_storage: 'granted',
      ad_storage: 'granted',
      ad_user_data: 'granted',
      ad_personalization: 'granted'
    };
    this.consentService.saveConsent(this.consentSettings);
    this.cookieService.enableGoogleAnalytics();
    this.gtmService.loadGoogleAnalytics();
    this.dialogRef.close();
    this.showFreshworkWidget(true);
    this.cookieService.saveConfig({
      analytics: true,
      isConfirmed: true
    });
    this.dialog.closeAll();
  }

  openSettings() {
    this.dialogService.open(this.customSettings, {
      disableClose: true,
      width: '90%',
      maxWidth: '600px',
      minHeight: '372px',
      panelClass: 'cookie-settings-dialog'
    });
  }

  toggleCookie() {
    this.analyticsCookie = !this.analyticsCookie;
    if (this.analyticsCookie) {
      this.cookieService.enableGoogleAnalytics();
    } else {
      this.cookieService.disableGoogleAnalytics();
    }
  }
  toggleAds() {
    this.adsCookie = !this.adsCookie;
  }

  confirmCustom() {
    this.analyticsCookie
      ? this.cookieService.enableGoogleAnalytics()
      : this.cookieService.disableGoogleAnalytics();

    this.cookieService.saveConfig(
      {
        analytics: this.analyticsCookie,
        isConfirmed: true
      },
      true
    );

    this.dialogRef.close();
  }

  closeDialog() {
    this.dialogRef.close();
  }

  closeAllDialogs() {
    this.dialog.closeAll();
  }

  // To Initialize/Destroy the widget (SEE: https://developers.freshdesk.com/widget-api/)
  private showFreshworkWidget(show: boolean) {
    if ((window as any).FreshworksWidget) {
      (window as any).FreshworksWidget(show ? 'show' : 'hide');
    }
  }

  ngOnDestroy(): void {
    if (this.consentSubscription) {
      this.consentSubscription.unsubscribe();
    }
  }
}
